module.exports = __webpack_public_path__ + "img/btn_link_1.2432e72f.png";